/* eslint-disable import/extensions, react/jsx-filename-extension */
/* eslint-disable react/require-default-props, react/forbid-prop-types */
/* eslint-disable react/no-unused-prop-types */
import { captureException } from '@sentry/browser'
import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { Navigate, Route, Routes } from 'react-router-dom'
import FeatureTogglesProvider from '../../shared/providers/FeatureTogglesProvider'
import KeyDownProvider from '../../shared/providers/KeyDownProvider'
import LocationHistoryProvider from '../../shared/providers/LocationHistoryProvider'
import { adjustScale } from '../../shared/helpers'
import NetworkMonitorProvider, {
  NetworkMonitorWrapper,
} from './providers/NetworkMonitorProvider'
import './App.scss'
import Deeplink from './components/Deeplink'
import focusable from './components/Focusable/Focusable.js'
import Screensaver from './components/Screensaver/Screensaver.js'
import { SidePanelLayout, SidePanelProvider } from './components/SidePanel'
import { showDonationFlag } from './lib/donationFlagLogger'
import { featureTogglesGet } from './lib/utils.js'
import Spinner from './components/Spinner/Spinner.js'
import SentryBoundary from './components/SentryBoundary'
import ActivationCodeScreen from './screens/ActivationCodeScreen'
import ActivationScreen from './screens/ActivationScreen'
import ChangeStationScreen from './screens/ChangeStationScreen'
import CollectionsScreen from './screens/CollectionsScreen'
import CancellationScreen from './screens/DonationCancelationScreen'
import ErrorScreen from './screens/ErrorScreen'
// TODO: skipped no-named-as-default are files with double exports, keep the default one
// eslint-disable-next-line import/no-named-as-default
import HomeScreen from './screens/HomeScreen/HomeScreen'
import InAppDonationScreen from './screens/InAppDonationScreen/InAppDonationScreen'
import LearnMore from './screens/InAppDonationScreen/LearnMore'
import LivePlayerError from './screens/LivePlayerScreen/LiveError.js'
import LivePlayerScreen from './screens/LivePlayerScreen/LivePlayerScreen'
import LivestreamScreen from './screens/Livestream/LivestreamScreen'
import LocalizationErrorScreen from './screens/LocalizationErrorScreen'
import LocatePrompt from './screens/LocatePromptScreen/LocatePrompt'
// eslint-disable-next-line import/no-named-as-default
import MyListScreen from './screens/MyListScreen/MyListScreen.js'
import MyStationScreen from './screens/MyStationScreen/MyStationScreen.js'
import PassportActivationScreen from './screens/PassportActivationScreen/PassportActivationScreen.js'
import PassPortUpsellWrapper from './screens/PassPortUpsell/PassPortUpsellWrapper'
import WhatIsPassportWrapper from './screens/PassportHandoffScreen/WhatIsPassportWrapper'
import SearchScreen from './screens/SearchScreen'
import SeasonsScreen from './screens/SeasonsScreen'
import SettingsScreen from './screens/SettingsScreen'
import ShowDetailsScreen from './screens/ShowDetailsScreen'
// eslint-disable-next-line import/no-named-as-default
import ShowsScreen from './screens/ShowsScreen/ShowsScreen.js'
import SignoutScreenTS from './screens/SignoutScreen/SignoutScreenTS'
// eslint-disable-next-line import/no-named-as-default
import SplashScreen from './screens/SplashScreen/SplashScreen.js'
import VideoDetailScreen from './screens/VideoDetailScreen'
import VppaProvider from './screens/VideoPlaybackScreen/context/VPPAModalProvider'
import VideoPlaybackScreen from './screens/VideoPlaybackScreen/VideoPlaybackScreen'
import { EvergreenMessagingProvider, EvergreenMoreInfo } from './components/EvergreenUrgentMessaging'
import { FEATURE_TOGGLES_CONFIGURATION } from './utils'

export class App extends React.Component {
  // constructor(props) {
  //   super(props)
  // }

  componentDidMount() {
    const { setFocus } = this.props
    setFocus?.()
    // run adjustScale after mounting the root to ensure we have the correct dimensions for scaling.
    adjustScale(document.getElementById('root'))
  }

  componentDidUpdate(prevProps) {
    if (COMPILING_FOR_COMCASTX1) {
      const { overlay } = this.props
      showDonationFlag(prevProps.overlay.enabled, overlay.enabled)
    }
  }

  componentDidCatch(e) {
    // if sentryboundary doesn't catch the error, this will catch and still have a blue screen
    // for now lets just capture it. if it still happens, we can add another error screen
    //  or fix the issue at that point
    captureException(e)
  }

  // TODO: review onKeyEvent legacy method and old focus hook
  // eslint-disable-next-line class-methods-use-this, react/no-unused-class-component-methods
  onKeyEvent(key) {
    if (key === 'BACK') {
      window.history.back()
    }

    return true
  }

  render() {
    return (
      <div aria-hidden="true" className="app" id="app">
        <SentryBoundary>
          <NetworkMonitorProvider>
            <FeatureTogglesProvider
              configuration={FEATURE_TOGGLES_CONFIGURATION}
              httpGet={featureTogglesGet}
            >
              <KeyDownProvider>
                <LocationHistoryProvider>
                  <SidePanelProvider>
                    <NetworkMonitorWrapper
                      // ErrorModal={ErrorModalTS}
                      Spinner={Spinner}
                    >
                      <Deeplink />
                      <Screensaver />
                      <EvergreenMessagingProvider>
                      <Routes>
                        <Route path="/" element={<SplashScreen />} />
                        <Route
                          path="/activate"
                          element={<ActivationScreen />}
                        />
                        <Route
                          path="/activatecode"
                          element={<ActivationCodeScreen />}
                        />
                        <Route element={<SidePanelLayout />}>
                          <Route path="/home" element={<HomeScreen />} />
                          <Route
                            path="/livestream"
                            element={<LivestreamScreen />}
                          />
                          <Route path="/shows" element={<ShowsScreen />} />
                          <Route path="/my-list" element={<MyListScreen />} />
                          <Route
                            path="/my-station"
                            element={<MyStationScreen />}
                          />
                          <Route path="/search" element={<SearchScreen />} />
                          <Route
                            path="/settings"
                            element={<SettingsScreen />}
                          />
                        </Route>
                        <Route
                          path="/passport-upsell/:callsign"
                          element={<PassPortUpsellWrapper />}
                        />
                        <Route
                          path="/video-details/:url"
                          element={<VideoDetailScreen />}
                        />
                        <Route
                          path="/show-details/:slug"
                          element={<ShowDetailsScreen />}
                        />
                        <Route
                          path="/video-playback/:url"
                          element={
                            <VppaProvider>
                              <VideoPlaybackScreen />
                            </VppaProvider>
                          }
                        />
                        <Route
                          path="/seasons/:show"
                          element={<SeasonsScreen />}
                        />
                        <Route
                          path="/collections/:url"
                          element={<CollectionsScreen />}
                        />
                        <Route
                          path="/change-station"
                          element={<ChangeStationScreen />}
                        />
                        <Route path="/sign-out" element={<SignoutScreenTS />} />
                        <Route path="/error" element={<ErrorScreen />} />
                        <Route
                          path="/in-app-donations"
                          element={<InAppDonationScreen />}
                        />
                        <Route
                          path="/learn-more"
                          element={<LearnMore />}
                        />
                        <Route
                          path="/what-is-passport"
                          element={<WhatIsPassportWrapper />}
                        />
                        <Route
                          path="/evergreen-more-info"
                          element={<EvergreenMoreInfo />}
                        />
                        <Route
                          path="/passport-activation"
                          element={<PassportActivationScreen />}
                        />
                        <Route
                          path="/live-playback/error"
                          element={<LivePlayerError />}
                        />
                        <Route
                          path="/live-playback"
                          element={<LivePlayerScreen />}
                        />
                        <Route
                          path="/locate-screen"
                          element={<LocatePrompt />}
                        />
                        <Route
                          path="/localization-error"
                          element={<LocalizationErrorScreen />}
                        />
                        <Route
                          path="/manage-donation/*"
                          element={<CancellationScreen />}
                        />
                        <Route path="*" element={<Navigate to="/" replace />} />
                      </Routes>
                      </EvergreenMessagingProvider>
                    </NetworkMonitorWrapper>
                  </SidePanelProvider>
                </LocationHistoryProvider>
              </KeyDownProvider>
            </FeatureTogglesProvider>
          </NetworkMonitorProvider>
        </SentryBoundary>
      </div>
    )
  }
}

App.propTypes = {
  setFocus: PropTypes.func,
  user: PropTypes.object,
  overlay: PropTypes.object,
}

const mapStateToProps = (state) => ({
  user: state.user,
  content: state.content,
  overlay: state.overlay,
})

export default connect(mapStateToProps, null, null)(focusable(App))
